// @flow

import React, { type Node } from 'react';
import amexSrc from './images/credit-card-amex.svg';
import magnaSrc from './images/credit-card-magna.svg';
import mastercardSrc from './images/credit-card-mastercard.svg';
import visaSrc from './images/credit-card-visa.svg';

export function DisplayWebpayBrand(): Node {
  const brandSources = {
    visa: visaSrc,
    mastercard: mastercardSrc,
    amex: amexSrc,
    magna: magnaSrc,
  };

  return (
    <div style={{ height: '24px', display: 'flex' }}>
      {Object.keys(brandSources).map(trait => (
        <div key={trait} style={{ flexGrow: 1, paddingLeft: '2%' }}>
          <img src={brandSources[trait]} alt={trait} />
        </div>
      ))}
    </div>
  );
}
